import { Injectable } from '@angular/core';
import { RoleDetail } from '../model';
import { BaseService } from '../../shared/baseService';
@Injectable({
    providedIn: 'root'
})

export class RoleDetailsService extends BaseService<RoleDetail> {
  
    constructor() {
        super('RoleDetail');
    }
}
